import MapProctorService from './mapProctorService';

export interface GetMapSessionRequest {
  student_id: string;
}

export interface SessionData {
  testSessionId: string | null;
  name: string | null;
  password: string | null;
}

export interface GetMapSessionResult {
  session?: SessionData;
  error?: string;
}

export async function getMapSession(input: GetMapSessionRequest): Promise<GetMapSessionResult> {
  try {
    const mapProctorService = MapProctorService.getInstance();
    return await mapProctorService.getCurrentSession(input.student_id);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
